export class Controller {

    /** @ngInject */
    constructor($filter, $state, AccountsResource, Alert, GroupsResource) {
        this.$filter = $filter;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.file = null;
        this.allowChangeOwner = true;
        this.verificationTypes = [
            {name: 'USER', selected: true},
            {name: 'ADMIN', selected: true},
        ];
    }

    selectCsv() {
        document.querySelector('input[type=file]').click();
    }

    uploadCSV() {

        const verificationTypes = this.verificationTypes
            .filter((verificationType) => verificationType.selected)
            .map((verificationType) => verificationType.name);

        this.AccountsResource
            .uploadUsers(this.companyId, verificationTypes, this.allowChangeOwner, this.file)
            .then((importResult) => {

                const accountIds = importResult.importedUsers
                    .map(({importedUser}) => importedUser.id)
                    .filter((v) => v);

                if (!accountIds.length) {
                    return importResult;
                }

                return this.GroupsResource
                    .createNewCustomGroup(
                        this.companyId,
                        `imported ${this.$filter('date')(new Date(), 'MM/dd/yyyy HH:mm:ss')}`
                    )
                    .then((group) => this.AccountsResource
                        .copyUsersToGroup(this.companyId, [group.id], accountIds)
                        .then(() => ({...importResult, group})))
            })
            .then((importResult) => this.$state.go('.upload-result', {importResult}, {reload: '^'}))
            .catch(({status}) => {
                document.querySelector('input[type=file]').value = '';
                this.file = null;
                if (status === 500 || status === 413) {
                    this.Alert('danger', 'company.user-directories.directory-groups.directory.import-users.failed');
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/import-users.controller.js